import { Component, OnInit } from '@angular/core';
import { LoginService } from 'src/app/services/login.service';
@Component({
  selector: 'service-training',
  templateUrl: './service-training.component.html',
  styleUrls: ['./service-training.component.less'],
})
export class ServiceTrainingComponent implements OnInit {
  constructor(
    public loginService: LoginService,
  ) { }

  ngOnInit(): void {
  }

}
